import React, { useEffect, useRef, useState } from 'react'
import './css/saasproducts.css'
import webimage from './Assets/webimage.png'
import AOS from 'aos'
import 'aos/dist/aos.css'

const TEXTS = [
    'Setting up your products/modules',
    'One platform. Total facility control.',
    'Make every asset count, every visit matter',
    'Track, manage, and optimize your facilities',
]
const STEP_MS = 1500

function Loading({ nextpage }) {
    const [index, setIndex] = useState(0)
    const nextRef = useRef(nextpage)
    nextRef.current = nextpage

    useEffect(() => {
        AOS.init({ duration: 1200, once: false })
    }, [])

    // advance through the texts once, then notify the parent after the last one has been shown
    useEffect(() => {
        const isLast = index === TEXTS.length - 1
        const timer = setTimeout(() => {
            if (isLast) nextRef.current?.(true)
            else setIndex((i) => i + 1)
        }, STEP_MS)
        return () => clearTimeout(timer)
    }, [index])

    useEffect(() => {
        AOS.refresh()
    }, [index])

    return (
        <div className="w-full min-h-screen absolute top-0 left-0 bg-white z-20 flex justify-center items-center">
            <div className="flex flex-col items-center gap-10">
                <div className="w-[250px] h-[250px] rounded-full rotate-border flex justify-center items-center">
                    <img src={webimage} className="w-20" alt="Loading" />
                </div>

                <p key={index} className="text-[40px] gradient-text text-center" data-aos="fade-up">
                    {TEXTS[index]}
                </p>
            </div>
        </div>
    )
}

export default Loading